<script>
import ItemsCart from './ItemsCart.svelte';
import { turpial } from '../../libraries/turpial.js';
import StripeCard from "tripod-styles/src/components/Elements/StripeCard.svelte";
import DlocalgoCheckbox from 'tripod-styles/src/components/Checkout/DlocalgoCheckbox.svelte';
import StripeCheckbox from 'tripod-styles/src/components/Checkout/StripeCheckbox.svelte';
import { PaymentProviderStore } from 'tripod-styles/src/components/Checkout/PaymentProviderStore.js';
import { StoreForm } from './StoreForm.js';
import { ItemCart, StoreCart } from './StoreCart';
import { AppForms } from '../../libraries/AppForms.js';
import PixelEventsHook from "tripod-styles/src/libraries/mybuilder/PixelEventsHook";
import RestartableController from 'tripod-styles/src/components/Elements/RestartableController.svelte';
import SimpleCheckbox from 'tripod-styles/src/components/Checkboxes/SimpleCheckbox.svelte';
import { PlanInterface } from 'tripod-styles/src/models/PlansInterface';
import { calculateRegionalPrice } from 'tripod-styles/src/libraries/regional_prices_calculator';
import { loadCurrencyRates, CurrenciesManagerStore } from 'tripod-styles/src/libraries/CurrenciesManagerStore';
import { onMount } from 'svelte';

export let changeStep;
export let Data;
export let errors;


let restartable_data = [{}];
let stripe_key;
Data.is_online = Data.is_online ?? true;

let stripe_account = $StoreForm.global_vars.stripe_account;
let version_field = (Data.is_online === true) ? "live" : "test"

if(stripe_account === "account_v2"){
    stripe_key = $StoreForm.global_vars.stripeTokens_v2[version_field];
}else if(stripe_account === "account_v3"){
    stripe_key = $StoreForm.global_vars.stripeTokens_v3[version_field];
}else{
    stripe_key = $StoreForm.global_vars.stripeTokens[version_field];
}


let lang = Data.lang;
let Affiliate = Data.affiliate;
let trial = Data.trial ?? false;
let formLang = lang.forms.planSelection;
let selectedPrice;
let buttonSubmit;
let form = null;
let IS_ONLINE =  tripod_register.is_online ?? false;
let couponElement = null;
let hasDiscountFromTag  = false;

/**
 * @type {PlanInterface}
 */
export let selectedPlan = {};
/**
 * @type {PlanInterface}
 */
let plan = selectedPlan.plan;
let addons = plan.addons||[];
let isSupportedDlocalgo = false;

let _host = IS_ONLINE ? "https://app.3pod.io/" : "https://beta.3pod.io/";
let csrf_url = `${_host}cs_unique/user?v=3`;
let csrf_token = null;
window.addEventListener("message", function(event){
// Check sender origin to be trusted
    try {
        if (event.origin.search("app.3pod.io") < 0){
            return;
        }
        let data = event?.data ?? {};
        csrf_token = data?.tkcs ?? null;
    } catch (error) {
        
    }
}, false);

$: if(isSupportedDlocalgo){
    PaymentProviderStore.setProvider("dlocalgo");
}

function sendEvent(){
    try {
        let dataRegister = $StoreForm.dataForm;
        dataRegister.userFromCampaign = tripod_register.userFromCampaign;
        dataRegister.add_trial_end = tripod_register?.add_trial_end ?? false;
        dataRegister.type_event = "Widget Registration";
        dataRegister.more_tags = tripod_register?.more_tags ?? "";
        dataRegister.charge_products = tripod_register.charge_products ?? [];
        
        let url;
        if(IS_ONLINE === false){
            url = "http://localhost/beta.3pod.io/public/api/v1/events/registerUser";
        }else{
            url = "https://app.3pod.io/public/api/v1/events/registerUser";
        }

        turpial.fetch({
            url: [url],
            method: "POST",
            type: "text",
            data: JSON.stringify({
                token: btoa(JSON.stringify(dataRegister)).split("").reverse().join(""),
            }),
            ready: (data)=>{
                new PixelEventsHook("Contact", "fbq");
                new PixelEventsHook("Lead", "fbq");
                console.log("Lead 2!");
            }
        })
    } catch (error) {
        console.log(error)
    }
}
sendEvent();

onMount(async () => {
    // Load currency rates using the shared library/store
    await loadCurrencyRates(Data.host);
    refreshCart();
});


function updateDataForm(){
    // update any error
    errors.hide();

    let data = AppForms.retrieve({
        form: form,
        targets: ".formElements",
    })
    StoreForm.update("dataForm", data, $StoreForm.dataForm);
    data = $StoreForm.dataForm;
    return data;
}

let activateCoupon = false;
if((Data?.activateCoupon ?? null) === true){
    activateCoupon = true;
}

let hasErrorForms = false;
function checkForm(data){
    let is_all_valid = true;
    data = data || {};

    // checks validation inputs.
    if(couponElement !== null){
        if(couponElement.dataset.valid === "false"){ is_all_valid = false; }
    }
    


    // check empty inputs
    let checks = ["first-name", "last-name", "email", "password", "phone", "city"];

    if($PaymentProviderStore.provider_id !== "dlocalgo"){
        checks.push("card_name_owner");
    }

    checks.map(( element )=>{
        if(typeof data[element] !== "string" && data[element] === ""){
            is_all_valid = false;
        }
    });

    
    
    return is_all_valid;
}

class generate_event_metadata
{
    constructor(plan, data)
    {
        // SEND EVENT AND CONSTRUCT EVENT METADATA.    
        let interval = plan?.interval_selected ?? 'undefined-interval';    
        let final_price = interval === "year" ? (plan.interval_price * 12) : plan.interval_price;

        let addons = Object.keys(plan.addons);

        let event_data = {
            tag: (Data?.userFromCampaign ?? 'N/A'),
            percent_off: plan?.percent_off ?? 0,
            addons: addons,
            email: data?.email ?? "",
            plan_id: plan?.interval_selected,
            interval: plan?.interval_selected ?? 'undefined-interval',
            name_plan: plan.name_plan,
            price_plan: final_price,
            membership: plan.membership_type,
        };

        return event_data;
    }
}

let stripeToken = "";
let payment_error = false;
function submitPayment(){
    let data = updateDataForm();
    let form_data = data;
    if(checkForm(data) === false){ 
        AppForms.statusButton(buttonSubmit, "enabled");
        errors.showError(lang.errors.uncompleted);
        return;
    }
    AppForms.statusButton(buttonSubmit, "disabled");

    payment_error = false;

    if ($PaymentProviderStore.provider_id === "dlocalgo") {
        data.payment_method = "dlocalgo";
        data.stripeToken = "dlocalgo";
        processPayment(data);
        return;
    }

    AppForms.statusButton(buttonSubmit, "disabled");

    tripod_register.stripe.module.createToken(tripod_register.stripe.card).then(function(result) {
        if (result.error) {
            // Inform the user if there was an error.
            tripod_register.stripe.cardErrorElement.textContent = result.error.message;
            AppForms.statusButton(buttonSubmit, "enabled");
        } else {
            // Send the token to your server.
            // send data to server             
            data.stripeToken = result?.token?.id||"none";
            processPayment(data);
        }
    });
}

function processPayment(data) {
    data.affiliate = Affiliate;
    data.userFromCampaign = tripod_register.userFromCampaign||"widget-registration";
    data.add_trial_end = tripod_register?.add_trial_end ?? false;
    data.more_tags = tripod_register?.more_tags ?? "";
    data.referral_code = Data?.referral_code || null;

    data.interval = plan.interval_selected;
    data.id_plan = plan.__id__;
    data.membership_type = plan.membership_type;
    data.addons = plan?.addons ?? [];
    

    data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(data.timezone === null){
        data.timezone = new Date().getTimezoneOffset();
    }
    if(data.timezone === null){
        try {
            data.timezone = "GMT"+new Date().toString().split("GMT")[1].split(" ")[0];
        } catch (error) {
            
        }
    }

    data.request = csrf_token;

    (function(){
        new PixelEventsHook("InitiateCheckout", "fbq");
    })();

    let main_data = data;
    let url;
    let path = "public/api/v1/widget_customer_subscription";
    if(IS_ONLINE === false){
        url = `${Data?.host_offline ?? "http://localhost/beta.3pod.io/"}${path}`;
    }else{
        url = `https://app.3pod.io/${path}`;
    }

    turpial.fetch({
        url: [url],
        data: JSON.stringify(data),
        method: "POST",
        type: "text",
        ready: (data)=>{                    
            data = JSON.parse(data[0]);
            let message = data?.message ?? "";
            if(data?.status === "error"){
                errors.showError(message);
                AppForms.statusButton(buttonSubmit, "enabled");
                return;
            }

            let redirect = data?.response?.url ?? data?.response?.redirect_url ?? null; 
            if(redirect === null){
                errors.showError(message);
                return;
            }
            
            if(typeof gtag !== "undefined"){
                try {
                    gtag('event', 'btn_sign_up_widget_register', {"send_to": "G-XEF7QBK3Z5", 'tag': (Data?.userFromCampaign ?? 'N/A'), 'user': main_data?.email ?? ""})
                    gtag('event', 'btn_sign_up_widget_purchase', {"send_to": "G-XEF7QBK3Z5"})

                    
                    let event_data = new generate_event_metadata(plan, $StoreForm.dataForm);

                    new PixelEventsHook("Purchase", "fbq", {currency: "usd", value: parseFloat(event_data.price_plan)});

                    try {
                        let on_purchase_events = window?.tripod_events?.on_purchase ?? null;
                        if(typeof on_purchase_events === "function"){
                            on_purchase_events(event_data);
                        }
                    } catch (error) {
                        console.error(error)
                    }

                    // on register events.
                    try {
                        let on_register_event = window?.tripod_events?.on_register ?? null;
                        if(typeof on_register_event === "function"){
                            on_register_event(event_data);
                        }
                    } catch (error) {
                        console.error(error)
                    }


                } catch (error) {
                    console.error(error)
                }
            }
            setTimeout(() => {
                window.location.href = redirect;
            }, 2500);
        },
        onerror: (data)=>{
            console.error(data)
            payment_error = true;
            AppForms.statusButton(buttonSubmit, "enabled");
        }
    })
}

function refreshCart(coupon = {}){
    coupon = coupon ?? {};
    let plan = selectedPlan.plan;
    let interval = selectedPlan.interval;
    let discountPercent = plan?.discountPercent ?? 0;
    let couponDiscount = coupon?.percent_off ?? 0;
    
    let totalDiscount = discountPercent + couponDiscount;

    function parseNum(n){
        return Number.parseFloat(Number.parseFloat(n).toFixed(2));
    }

    StoreCart.restore();

    const currencies_conversion = $CurrenciesManagerStore.currencies_conversion;
    const code_country = $StoreForm.dataForm.code_country || tripod_register.code_country || "";
    
    // Apply Regional Pricing
    const regionalPriceData = calculateRegionalPrice(plan, code_country, currencies_conversion);
    if (regionalPriceData) {
        console.log(`Applying regional pricing for ${plan.name_plan} in Cart:`, regionalPriceData);
        plan = {
            ...plan,
            price_plan: regionalPriceData.price_plan,
            interval_year_price: regionalPriceData.interval_year_price,
            currency: regionalPriceData.currency, // Pass this to ItemCart
        };
        // Update Data.currency if it matches the plan's currency (optional, but good for consistency)
        Data.currency = regionalPriceData.currency;
    }

    new ItemCart({
        type: "plan",
        plan: plan,
        membership_type: plan.membership_type,
        interval: interval,
        discountPercent: totalDiscount,
        icon: plan.img_plan,
        name: plan.name_plan,
        currency: plan.currency, // Pass regional currency to ItemCart
        prices: {
            month: {
                current: parseNum(plan.price_plan),
            },
            year: {
                current: parseNum(parseNum(plan?.interval_year_price ?? parseNum(plan.price_plan))*12),
            }
        },
    }).add();


    Object.values(plan.addons).map(( addon, key )=>{
        if(addon.price <= 0){ return; }
        
        new ItemCart({
            type: "addon",
            plan: addon.plan,
            interval: interval,
            discountPercent: totalDiscount,
            icon: addon.plan.img_plan,
            name: addon.plan.name_plan,
            prices: {
                month: {
                    current: parseNum(addon.price),
                },
                year: {
                    current: parseNum(addon.price*12),
                }
            },
        }).add();
    })

    restartable_data = [{}];
}

function checkCoupon(couponElement, button, interval = "month"){
    let input = couponElement;
    if(input.value === ""){
        input.classList.remove("coupon-success");
        input.classList.remove("coupon-error");
        input.dataset.valid = true;
        refreshCart();
        return;
    }

    if(input.value.length <= 3){
        input.classList.add("coupon-error");
        input.classList.remove("coupon-success");
        input.dataset.valid = false;
        return;
    }

    button.setAttribute("disabled", "");
    button.classList.add("is-loading");

    let coupon_value = input.value

    let url;
    if(IS_ONLINE === false){
        url = `http://localhost/beta.3pod.io/public/api/v1/getCoupon?coupon=${coupon_value}&interval=${interval}`;
    }else{
        url = `https://app.3pod.io/public/api/v1/getCoupon?coupon=${coupon_value}&interval=${interval}`;
    }

    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            coupon: coupon_value,
            interval: interval
        })
    }).then((response) => response.json()).then((data) => {
        if(data?.status === "success"){
            input.classList.add("coupon-success");
            input.classList.remove("coupon-error");
            input.dataset.valid = true;

            refreshCart(data.response);

        }else{
            input.classList.add("coupon-error");
            input.classList.remove("coupon-success");
            input.dataset.valid = false;

            refreshCart();
        }
    }).catch((error) => {
        console.error(error)
        input.classList.add("coupon-error");
        input.classList.remove("coupon-success");
        input.dataset.valid = false;

        refreshCart();
    }).finally(() => {
        button.removeAttribute("disabled");
        button.classList.remove("is-loading");
    })
}
</script>
<div class="container-payment-element">
    <header>
        <iframe src="{csrf_url}" title="tk" frameborder="0" class="is-sr-only"></iframe>
        <h2 class="has-text-black fw700 font-size-24 title-second-step">
            Checkout
        </h2>
        <h2 class="has-text-black fw700 font-size-24">
            Paso 3 de 3
        </h2>
    </header>
    <RestartableController bind:data={restartable_data}>
        <main>
            <form action="" on:input|preventDefault="{ updateDataForm }" on:submit|preventDefault="{ submitPayment }" bind:this="{form}">
                <input type="hidden" name="stripeToken" value={stripeToken}>
                <input type="hidden" name="card_name_owner" value={stripeToken}>
                <div class="columns is-multiline">
                    <section class="column is-12 is-paddingless">                    
                        <ItemsCart lang={lang} Data={Data} plan={plan} interval={plan.interval_selected} />
                    </section>
                    <section class="column is-12">
                        <div class="columns is-multiline" style="padding: 1.45rem 0">
                            {#if trial === false}
                                {#if hasDiscountFromTag === false || activateCoupon === true}
                                    <div class="field field-input has-addons is-align-items-flex-end column is-12 field-payment-funnels field-coupon is-12-touch">
                                        <div class="control has-text-left full-width">
                                            <label for="" class="fw600 label-text">{formLang.coupon}</label>
                                            <input bind:this="{couponElement}" type="text" value="{$StoreForm?.dataForm["coupon"] ?? ""}" name="coupon" placeholder="{formLang.coupon}" class="input formElements coupon is-fullwidth" minlength="4">
                                        </div>
                                        <div class="control">
                                            <button type="button" on:click={function(e){ checkCoupon(couponElement, e.target, plan.interval_selected) }} class="button is-primary is-marginless">
                                                {formLang?.coupon_apply ?? "Aplicar"}
                                            </button>
                                        </div>
                                    </div>
                                {/if}
                                <div class="field field-input column field-payment-funnels is-12-touch">
                                    <div class="control has-text-left">
                                        <label for="" class="fw600 label-text">Método de pago</label>
                                        <div class="payment-methods-selection is-grid is-gap-20">
                                            <DlocalgoCheckbox 
                                                bind:isSupported={isSupportedDlocalgo}
                                                checked={$PaymentProviderStore.provider_id === "dlocalgo"}
                                                on:change={() => PaymentProviderStore.setProvider("dlocalgo")}
                                                name_input="payment_provider"
                                                country_set={$StoreForm?.dataForm?.code_country}
                                                is_online_context={IS_ONLINE}
                                                api_host={(Data?.host_offline ?? "http://localhost/beta.3pod.io/") + "api/v1/services/"}
                                            />
                                            <!-- When dlocalgo is supported do not show stripe. -->
                                            {#if isSupportedDlocalgo === false}
                                                <StripeCheckbox 
                                                    checked={$PaymentProviderStore.provider_id === "stripe"}
                                                    on:change={() => PaymentProviderStore.setProvider("stripe")}
                                                    name_input="payment_provider"
                                                />
                                            {/if}
                                        </div>
                                    </div>
                                </div>

                                {#if $PaymentProviderStore.provider_id === "stripe"}
                                    <div class="field field-input field-payment-funnels column is-12">
                                        <div class="control has-text-left">
                                            <label for="" class="fw600 label-text">{formLang.card_name_owner}</label>
                                            <input type="text" value="{$StoreForm?.dataForm["card_name_owner"] ?? ""}" name="card_name_owner" placeholder="{formLang.card_name_owner}" class="input formElements is-fullwidth" minlength="4" required>
                                        </div>
                                    </div>
                                    <div class="field field-input column field-payment-funnels is-12 field-stripe-card is-12-touch">
                                        <div class="control has-text-left">
                                            <label for="" class="fw600 label-text">{formLang.card}</label>
                                            <StripeCard stripe_key={stripe_key} />                    
                                        </div>
                                    </div>
                                {/if}
                            {/if}
                            <div class="field field-payment-funnels column is-12">
                                {#if payment_error}
                                    <div class="error-message-3pod">
                                        <p class="has-text-danger has-text-centered">
                                            Su pago ha sido rechazado o ha ocurrido un error inesperado.
                                        </p>
                                    </div>
                                {/if}
                                <div class="buttons is-grouped is-centered">
                                    <button bind:this={buttonSubmit} type="submit" class="button is-primary is-fullwidth">
                                        {formLang.button}
                                    </button>
                                </div>
                                <div class="field field-input field-payment-agreement column is-12">
                                    <div class="pb-alt-1">
                                        <hr class="my-0">
                                    </div>
                                    <p class="has-text-left font-restricted-size-14 fw400 agree-terms-3pod">
                                        {@html lang?.forms?.agree_payment}
                                    </p>
                                </div>
                                <div class="navigation under--navigation-text">
                                    <p class="is-underlined pointer under--navigation-back">
                                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                                        <span on:click={changeStep("BasicForm")}>
                                            {lang.goBack}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>                    
                    </section>                
                </div>
            </form>
        </main>
    </RestartableController>
</div>
<style>
.container-payment-element{
    width: 100%;
    padding: 0 10%;
    max-width: 600px;
}
@media only screen and (max-width: 1023px){
    .container-payment-element{
        width: 100%;
        padding: 0 5%;
    }
}
main{
    margin-top: 1.25rem;
    padding-top: 1.25rem;
}
.coupon:global(.coupon-success), .coupon:global(.coupon-success:focus){
    border: 1px solid var(--color-green);
}
.coupon:global(.coupon-error), .coupon:global(.coupon-error:focus){
    border: 1px solid var(--color-red);
}
header{
    position: relative;
    margin-bottom: 1.25rem;
}
@media only screen and (max-width:768px){
    .field-payment-funnels{
        padding: 0.25rem 0.75rem;
    }
}
</style>